export default {
      id: "circle-external-joblanit-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "sprite-46b249.svg#circle-external-joblanit-usage",
      toString: function () {
        return this.url;
      }
    }